import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environmet';
import {
  CreateSmartCullUserRequest,
  SmartCullUserItem,
  PagedSmartCullUsersResponse,
  UpdateSmartCullUserRequest,
  ApiResponse
} from '../models/smart-cull-user.models';

@Injectable({
  providedIn: 'root'
})
export class SmartCullApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/smart-cull-users`;

  // We are keeping companyId parameter but sending 1 as default going forward as instructed
  // However, the backend endpoint didn't specify taking companyId in the route `/api/smart-cull-users`.
  // We will omit it from the request params since the user provided: `/api/smart-cull-users?pageNumber=1&pageSize=20`
  getSmartCullUsers(
    pageNumber: number,
    pageSize: number,
    searchTerm: string,
    isActive?: boolean
  ): Observable<ApiResponse<PagedSmartCullUsersResponse>> {
    let params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString());

    if (searchTerm) {
      params = params.set('search', searchTerm);
    }

    if (isActive !== undefined) {
      params = params.set('isActive', isActive.toString());
    }

    return this.http.get<ApiResponse<PagedSmartCullUsersResponse>>(this.baseUrl, { params });
  }

  createSmartCullUser(
    payload: CreateSmartCullUserRequest
  ): Observable<ApiResponse<any>> {
    return this.http.post<ApiResponse<any>>(this.baseUrl, payload);
  }

  updateSmartCullUser(
    userId: number,
    payload: UpdateSmartCullUserRequest
  ): Observable<ApiResponse<any>> {
    return this.http.put<ApiResponse<any>>(`${this.baseUrl}/${userId}`, payload);
  }

  deleteSmartCullUser(userId: number): Observable<ApiResponse<string>> {
    return this.http.delete<ApiResponse<string>>(`${this.baseUrl}/${userId}`);
  }

  resetSmartCullUserPassword(userId: number): Observable<ApiResponse<string>> {
    return this.http.post<ApiResponse<string>>(`${this.baseUrl}/${userId}/reset-password`, {});
  }
}